import {Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  width: 18px;
`;

const StyledDot = styled(Stack)`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${({theme}) => theme.colors.light.text.secondary};
  animation: bounce 1.5s infinite ease-in-out;
  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-8px);
    }
  }
`;

export {StyledContainer, StyledDot};
